var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 4.50004V3.96671C10.6667 3.21997 10.6667 2.8466 10.5213 2.56139C10.3935 2.3105 10.1895 2.10653 9.93865 1.9787C9.65344 1.83337 9.28007 1.83337 8.53333 1.83337H7.46667C6.71993 1.83337 6.34656 1.83337 6.06135 1.9787C5.81046 2.10653 5.60649 2.3105 5.47866 2.56139C5.33333 2.8466 5.33333 3.21997 5.33333 3.96671V4.50004M6.66667 8.16671V11.5M9.33333 8.16671V11.5M2 4.50004H14M12.6667 4.50004V11.9667C12.6667 13.0868 12.6667 13.6469 12.4487 14.0747C12.2569 14.451 11.951 14.757 11.5746 14.9487C11.1468 15.1667 10.5868 15.1667 9.46667 15.1667H6.53333C5.41323 15.1667 4.85318 15.1667 4.42535 14.9487C4.04903 14.757 3.74307 14.451 3.55132 14.0747C3.33333 13.6469 3.33333 13.0868 3.33333 11.9667V4.50004",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.49e7e1c0750cae8817b8039d4a24119e.svg";
export { ForwardRef as ReactComponent };